import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Subject } from 'rxjs';
import { filter, takeUntil, take } from 'rxjs/operators';
import { AppConfig, Theme } from '../core/config/app.config';
import { Layout } from './layout.types';
import { CalsoftConfigService } from 'src/app/global/services/config';
import { CalsoftDrawerService } from 'src/app/global/components/drawer';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from '../services/config.service';
import { CrmsettingsService } from '../services/crmsettings.service';
import { Constant } from '../constant/constant';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';
import { CommonService } from '../services/common.service';
import { SubscriptionsService } from '../services/subscriptions.service';
import { PhoneNumbersService } from '../services/phone-numbers.service';
import { SupplierService } from '../services/supplier.service';
import { CountryStateCityService } from '../services/country-state-city.service';

@Component({
  selector: 'layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit, OnDestroy {

  private readonly subscriptionPlanSelectionRoute = '/subscription/plan-selection';
  private readonly renewalAllowedRoutePrefixes = [
    '/subscription/plan-selection',
    '/subscription/checkout',
    '/sign-out',
    '/sign-in',
    '/renew',
    '/renewal'
  ];
  private restrictToRenewalFlow = false;

  sanitizedUrl: string = '';


  url = '';

  config: AppConfig;
  layout: Layout;
  theme: Theme;

  // Private
  private _unsubscribeAll: Subject<any>;
  data: any;
  mainBgColor: any = '#0b27c2';
  leftMenuColor: any;
  leftMenuHoverColor: any;
  leftBackgroundColor: any;
  mainBackgroundColor: any;
  mainfontcolor: any;
  adminBreadcrumbType: any;
  plan: any;

  /**
   * Constructor
   *
   * @param {ActivatedRoute} _activatedRoute
   * @param {CalsoftConfigService} _calsoftConfigService
   * @param {CalsoftDrawerService} _calsoftDrawerService
   * @param {DOCUMENT} _document
   * @param {Router} _router
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _calsoftConfigService: CalsoftConfigService,
    private _calsoftDrawerService: CalsoftDrawerService,
    @Inject(DOCUMENT) private _document: any,
    private _router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private configService: ConfigService,
    public crmsetting: CrmsettingsService,
    private ecryptService: EcryptServiceService,
    private commonService: CommonService,
    private changeDetector: ChangeDetectorRef,
    private subscriptionsService: SubscriptionsService,
    private phoneNumbersService: PhoneNumbersService,
    private supplierService: SupplierService,
    private countryStateCityService: CountryStateCityService
  ) {

    this._unsubscribeAll = new Subject();
    this.url = this._router.url || '';
    this._router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this._router.url || ''; });
  }

  ngOnInit(): void {


    this.plan = localStorage.getItem('plan');
    this.checkfreeTrial();
    this.loadCountries();
    this.vendorExpire();
    this.redirectToPlanSelectionIfNeeded();
    this.getConfigData();
    this.getCrmSettingData();


    this._calsoftConfigService.config$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config: AppConfig) => {

        this.config = config;

        this.theme = config.theme;

        const themeName = 'calsoft-theme-' + config.theme;
        this._document.body.classList.forEach((className) => {
          if (className.startsWith('calsoft-theme-') && className !== themeName) {
            this._document.body.classList.remove(className);
            this._document.body.classList.add(themeName);
            return;
          }
        });
        this._updateLayout();
      });

    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this._unsubscribeAll)
    ).subscribe(() => {

      this.enforceRestrictedNavigation(this._router.url || '');

      this._updateLayout();
    });
  }

  private isLoggedIn(): boolean {
    try {
      if (Constant.DEVICE_TYPE === 'MOBILE') {
        return Boolean(localStorage.getItem(Constant.X_XSRF_TOKEN));
      }

      const prefix = `${Constant.X_XSRF_TOKEN}=`;
      for (const cookieChunk of document.cookie.split(';')) {
        const cookie = cookieChunk.trim();
        if (cookie.startsWith(prefix)) return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }


  loadCountries() {
    this.countryStateCityService.getAllCountries()
      .pipe(take(1))
      .subscribe(
        res => {


        },
        error => {
          console.error('Error loading countries', error);
        }
      );
  }

  accountDetails: any;

  trialExpiredMessage: any;

  checkfreeTrial() {
    this.subscriptionsService.checkFreeTrail()
      .pipe(take(1))
      .subscribe(
        data => {
          if (data != null) {
            this.accountDetails = data;
            this.trialExpiredMessage = this.subscriptionsService.getSubscriptionMessage(this.accountDetails);
            this.subscriptionsService.updateTrialExpiredMessage(this.trialExpiredMessage);
          }
        },
        error => {
          console.error('checkfreeTrial failed', error);
        }
      )
  }


  getConfigData() {
    this.configService.getConfigDataNew()
      .pipe(take(1))
      .subscribe(
        (response: any) => {


          let data = response;

          let config = response;

          if (response.encryptedText != null) {
            const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
            data = JSON.parse(decrypted);
          }


          this.data = data;



          if (data != null) {
            const encryptedConfig = this.ecryptService.encryptionAES(JSON.stringify(data));
            localStorage.setItem('configSettingsData', encryptedConfig);

            if (data['baseUrl'] != undefined) {
              let baseUrl = data['baseUrl'];

              this.commonService.setBaseUrl(baseUrl);
              localStorage.setItem('baseUrl', baseUrl);
            }


            if (data['defaultProductSet'] != undefined) {
              let defaultProductSet = data['defaultProductSet'];
              localStorage.setItem('filterType', defaultProductSet);
            }

            if (data['mainBgColor'] != undefined) {
              this.mainBgColor = data['mainBgColor'];
              document.documentElement.style.setProperty('--mainbackground-color', this.mainBgColor);
            }


            if (data['filterType'] != undefined) {
              let filterType = data['filterType'];
              localStorage.setItem('filterType', filterType);
            }
            if (data['gridType'] != undefined) {
              let gridType = data['gridType'];
              localStorage.setItem('gridType', gridType);
            }

            if (data['storeName'] != undefined) {
              let storeName = data['storeName'];
              localStorage.setItem('storeName', storeName);
            }
            if (data['leftMenuColor'] != undefined) {
              this.leftMenuColor = data['leftMenuColor'];
              document.documentElement.style.setProperty('--leftprimary-color', this.leftMenuColor);
            }
            if (data['leftMenuHoverColor'] != undefined) {
              this.leftMenuHoverColor = data['leftMenuHoverColor'];
              document.documentElement.style.setProperty('--leftmenuhover-color', this.leftMenuHoverColor);
            }
            if (data['leftMenuBgColor'] != undefined) {
              this.leftBackgroundColor = data['leftMenuBgColor'];
              document.documentElement.style.setProperty('--leftbackground-color', this.leftBackgroundColor);
            }
            if (data['mainfontcolor'] != undefined) {
              this.mainBackgroundColor = data['mainfontcolor'];
              document.documentElement.style.setProperty('--backgroundmain-color', this.mainBackgroundColor);
            }

            if (data['adminLayout'] != undefined) {

              localStorage.setItem("layout", data['adminLayout'])
            }


          }



        }, error => {

        }
      );
  }

  dialerType: any;

  // FreJun Dialer state
  frejunDialerVisible: boolean = false;
  frejunDialerLoaded: boolean = false;
  frejunAuthRequired: boolean = false;
  frejunAuthorizationToken: string = '';
  frejunEmail: string = '';
  frejunWidgetHeight: number = 550;
  frejunAuthErrorDetail: string = '';
  private frejunMessageListener: ((event: MessageEvent) => void) | null = null;
  private frejunCallEventListener: ((event: Event) => void) | null = null;

  getFrejunEmail(): string {
    if (this.frejunEmail && this.frejunEmail.trim()) {
      return this.frejunEmail.trim();
    }
    const candidateKeys = ['email', 'authenticaterUserEmail', 'userEmail', 'user_email'];
    for (const key of candidateKeys) {
      const val = localStorage.getItem(key);
      if (val && val.trim() && val.includes('@')) {
        return val.trim();
      }
    }
    const userName = localStorage.getItem('userName');
    if (userName && userName.trim() && userName.includes('@')) {
      return userName.trim();
    }
    return '';
  }

  getCrmSettingData() {
    this.crmsetting.getCrmSettingsData()
      .pipe(take(1))
      .subscribe(
        res => {

          if (res != null) {

            const encrypted = this.ecryptService.encryptionAES(JSON.stringify(res));
            localStorage.setItem('crmSettingsData', encrypted);

            this.dialerType = res['dialerType'];

            this.frejunAuthorizationToken = res['authorizationToken'] || '';

            this.frejunEmail = res['callerId'] ? res['callerId'].toString().trim() : '';
            if (!this.frejunEmail) {
              this.frejunEmail = this.getFrejunEmail();
            }

            if (res['userDropDownType'] != null && res['userDropDownType'] != undefined) {
              localStorage.setItem('userDropDownType', res['userDropDownType']);
            } else {
              localStorage.setItem('userDropDownType', "1");
            }

            if (this.dialerType == 7) {
              this.initDialer();
            } else if (this.dialerType == 8) {
              this.getAssignUsersById();
            } else if (this.dialerType == 12) {
              // Keep dialer hidden on startup; iframe loads in background for silent auth
              this.frejunDialerVisible = false;
              this.setupFrejunMessageListener();
            }

          }

        },
        error => {
        }
      )
  }

  setupFrejunMessageListener() {
    if (!this.frejunMessageListener) {
      this.frejunMessageListener = this.handleFrejunMessageEvent.bind(this);
      window.addEventListener('message', this.frejunMessageListener);
    }
    // Listen for calls dispatched by child components (common-product, lead-detail, sequencestasks, etc.)
    if (!this.frejunCallEventListener) {
      this.frejunCallEventListener = (event: Event) => {
        const detail = (event as CustomEvent).detail || {};
        this.frejunDialerVisible = true;
        this.frejunInitiateCall(detail.number || detail.candidate_number || '', detail.name || detail.candidate_name || '', detail);
      };
      window.addEventListener('frejun:initiate-call', this.frejunCallEventListener);
      // Simple show-dialer event (no call, just open)
      window.addEventListener('frejun:show-dialer', () => { this.frejunDialerVisible = true; });
      window.addEventListener('frejun:end-call', () => { this.frejunEndCall(); });
    }
  }

  handleFrejunMessageEvent(event: MessageEvent) {
    const TARGET_ORIGIN = 'https://dialer.frejun.com';
    const isAllowedOrigin = event.origin === TARGET_ORIGIN ||
      (event.origin && event.origin.includes('frejun.com')) ||
      event.origin === window.location.origin ||
      (event.origin && event.origin.includes('localhost'));

    if (!isAllowedOrigin || !event.data) return;

    let eventData = event.data;
    if (typeof eventData === 'string') {
      try { eventData = JSON.parse(eventData); } catch (e) { return; }
    }
    if (!eventData || typeof eventData !== 'object' || !eventData.eventName) return;

    console.log('FreJun [layout] event:', eventData.eventName, eventData);
    switch (eventData.eventName) {
      case 'ready':
        this.frejunDialerLoaded = true;
        this.frejunAuthRequired = true;
        this.frejunHandleAuthorization();
        break;

      case 'unauthorized':
        this.frejunAuthRequired = true;
        this.frejunAuthErrorDetail = eventData.detail || 'Authorization failed';
        console.error('FreJun Authorization Failed:', eventData.detail);
        if (eventData.detail) {
          try {
            this.snackBar.open(`FreJun Unauthorized: ${eventData.detail}`, 'Close', {
              duration: 7000,
              panelClass: 'error'
            });
          } catch (e) {}
        }
        break;

      case 'incoming-call':
        this.frejunDialerVisible = true;
        break;

      case 'close':
        this.frejunDialerVisible = false;
        break;

      case 'height-change': {
        const newHeight = parseInt(eventData.detail, 10);
        if (!isNaN(newHeight) && newHeight > 0) {
          this.frejunWidgetHeight = newHeight;
          this.changeDetector.detectChanges();
        }
        break;
      }

      case 'call-ended':
        console.log('FreJun: Call ended');
        break;

      case 'end-call-error':
        console.error('FreJun: End call error:', eventData.detail);
        break;

      default:
        console.log('FreJun event:', eventData.eventName, eventData);
        break;
    }
  }

  frejunPostMessage(iframeWin: Window, message: any) {
    const TARGET_ORIGIN = 'https://dialer.frejun.com';
    try {
      iframeWin.postMessage(message, { targetOrigin: TARGET_ORIGIN + '/' } as any);
    } catch (e) {
      try {
        iframeWin.postMessage(message, 'https://dialer.frejun.com/');
      } catch (err) {
        iframeWin.postMessage(message, '*');
      }
    }
  }

  frejunHandleAuthorization() {
    if (!this.frejunDialerLoaded) return;

    const token = this.frejunAuthorizationToken ? this.frejunAuthorizationToken.toString().trim() : '';
    const email = this.getFrejunEmail();

    if (!token) {
      console.warn('FreJun: Authorization Token is empty! Configure it in CRM Settings.');
      return;
    }

    if (!email) {
      console.warn('FreJun: user_email is empty! Ensure callerId is set in CRM Settings or user is logged in.');
      return;
    }

    const iframeElem = document.querySelector('#frejun-global-iframe') as HTMLIFrameElement;
    if (!iframeElem || !iframeElem.contentWindow) return;

    const message = {
      eventName: 'authorize',
      data: { access_token: token, user_email: email }
    };

    console.log('FreJun [layout] Sending authorization:', message);
    this.frejunPostMessage(iframeElem.contentWindow, message);
    this.frejunAuthRequired = false;
  }

  frejunInitiateCall(candidateNumber: string, candidateName?: string, optionalData?: any) {
    this.frejunDialerVisible = true;

    const iframeElem = document.querySelector('#frejun-global-iframe') as HTMLIFrameElement;
    if (!iframeElem || !iframeElem.contentWindow) return;

    let formattedNumber = candidateNumber ? candidateNumber.toString().trim() : '';
    if (formattedNumber && !formattedNumber.startsWith('+')) {
      formattedNumber = '+' + formattedNumber;
    }

    const email = this.getFrejunEmail();
    const token = this.frejunAuthorizationToken ? this.frejunAuthorizationToken.toString().trim() : '';

    const callData: any = {
      user_email: email,
      candidate_number: formattedNumber,
      access_token: token
    };

    if (candidateName && candidateName.trim()) {
      callData.candidate_name = candidateName.trim();
    }

    if (optionalData && typeof optionalData === 'object') {
      ['virtual_number', 'transaction_id', 'job_id', 'candidate_id'].forEach(key => {
        if (optionalData[key] && optionalData[key].toString().trim()) {
          callData[key] = optionalData[key].toString().trim();
        }
      });
    }

    const message = {
      eventName: 'initiate-call',
      data: callData
    };

    // If authorization is required/pending, authorize first and delay call initiation
    const delay = this.frejunAuthRequired ? 600 : 50;
    if (this.frejunAuthRequired) {
      this.frejunHandleAuthorization();
    }

    setTimeout(() => {
      console.log('FreJun [layout] Initiating call:', message);
      this.frejunPostMessage(iframeElem.contentWindow, message);
    }, delay);
  }

  frejunEndCall() {
    const iframeElem = document.querySelector('#frejun-global-iframe') as HTMLIFrameElement;
    if (!iframeElem || !iframeElem.contentWindow) return;

    const message = { eventName: 'end-call' };
    console.log('FreJun [layout] Sending end-call:', message);
    this.frejunPostMessage(iframeElem.contentWindow, message);
  }

  /**
   * 
   * 
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    this._onDestroy.next();
    this._onDestroy.complete();
    if (this.frejunMessageListener) {
      window.removeEventListener('message', this.frejunMessageListener);
      this.frejunMessageListener = null;
    }
    if (this.frejunCallEventListener) {
      window.removeEventListener('frejun:initiate-call', this.frejunCallEventListener);
      this.frejunCallEventListener = null;
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the selected layout
   */
  private _updateLayout(): void {
    // Get the current activated route
    let route = this._activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }

    // 1. Set the layout from the config
    this.layout = this.config.layout;

    // 2. Get the query parameter from the current route and
    // set the layout and save the layout to the config
    const layoutFromQueryParam = (route.snapshot.queryParamMap.get('layout') as Layout);
    if (layoutFromQueryParam) {
      this.config.layout = this.layout = layoutFromQueryParam;
    }

    // 3. Iterate through the paths and change the layout as we find
    // a config for it.
    //
    // The reason we do this is that there might be empty grouping
    // paths or componentless routes along the path. Because of that,
    // we cannot just assume that the layout configuration will be
    // in the last path's config or in the first path's config.
    //
    // So, we get all the paths that matched starting from root all
    // the way to the current activated route, walk through them one
    // by one and change the layout as we find the layout config. This
    // way, layout configuration can live anywhere within the path and
    // we won't miss it.
    //
    // Also, this will allow overriding the layout in any time so we
    // can have different layouts for different routes.
    const paths = route.pathFromRoot;
    paths.forEach((path) => {

      // Check if there is a 'layout' data
      if (path.routeConfig && path.routeConfig.data && path.routeConfig.data.layout) {
        // Set the layout
        this.layout = path.routeConfig.data.layout;
      }
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Set the layout on the config
   *
   * @param layout
   */
  setLayout(layout: string): void {
    // Clear the 'layout' query param to allow layout changes
    this._router.navigate([], {
      queryParams: {
        layout: null
      },
      queryParamsHandling: 'merge'
    }).then(() => {

      // Set the config
      this._calsoftConfigService.config = { layout };
    });
  }

  /**
   * Set the theme on the config
   *
   * @param change
   */
  setTheme(change: MatSlideToggleChange): void {
    this._calsoftConfigService.config = { theme: change.checked ? 'dark' : 'light' };
  }

  dialerEnable: boolean = false;
  iframeUrl: string = '';

  initDialer() {

    this.dialerEnable = true;

    const userId = localStorage.getItem('userId');
    const companyId = localStorage.getItem('storeName');

    const baseUrl = 'https://client5.rekzyl.com/voice/dialpad';
    const params = new URLSearchParams({
      leftServiceId: '93eeb600-dcb1-4382-bf11-846c467deb79',
      service: 'calsoft',
      sideBar: 'false',
      topBar: 'false',
      fullView: 'false',
      userId: userId,
      companyId: companyId,
    });

    this.iframeUrl = `${baseUrl}?${params.toString()}`;
    this.changeDetector.detectChanges();
  }

  closeDialer() {
    this.dialerEnable = false;
  }

  @ViewChild('myHelloSendFrame', { static: false }) myHelloSendFrame: ElementRef;
  onIframeLoaded() {
    setTimeout(() => {
      if (!this.myHelloSendFrame?.nativeElement) {
        console.error('iframe element not yet available');
        return;
      }

    }, 0);
  }

  assignUsersIdList: any = {};

  getAssignUsersById() {
    this.phoneNumbersService.getUserById()
      .pipe(take(1))
      .subscribe(
        data => {
          this.assignUsersIdList = data;
          const encrypted = this.ecryptService.encryptionAES(JSON.stringify(this.assignUsersIdList));
          localStorage.setItem('phoneNoList', encrypted);
        }
      );
  }


  vendorExits: any;

  vendorExpire() {
    this.supplierService.checkVendorSubscriptionNew()
      .pipe(take(1))
      .subscribe(
        data => {

          this.vendorExits = data;

          localStorage.setItem("enableExchange", this.vendorExits.enableExchange);

          localStorage.setItem("exchangeOrderType", this.vendorExits.userType);

          if (this.vendorExits.expired == 1) {
            this.restrictToRenewalFlow = true;
            localStorage.setItem('SubscriptionExpired', 'true');

            try {
              // store an explicit expired message so renewal page can display it
              const msg = 'Your account has expired. Please renew to continue.';
              const encryptedMsg = this.ecryptService.encryptionAES(JSON.stringify(msg));
              localStorage.setItem('trialExpiredMessage', encryptedMsg);
            } catch (e) {
              console.warn('Failed to store expired message', e);
            }

            this._router.navigate([this.subscriptionPlanSelectionRoute], { replaceUrl: true }).then(() => { });

          } else {
            localStorage.setItem('SubscriptionExpired', 'false');
          }



        },
        error => {
        }
      )
  }

  private redirectToPlanSelectionIfNeeded(): void {
    this.subscriptionsService.getSubscriptionSummary()
      .pipe(take(1))
      .subscribe(
        (summary: any) => {
          if (!this.shouldRedirectToPlanSelection(summary)) {
            this.restrictToRenewalFlow = false;
            localStorage.setItem('SubscriptionExpired', 'false');
            return;
          }

          this.restrictToRenewalFlow = true;
          localStorage.setItem('SubscriptionExpired', 'true');

          if (this._router.url !== this.subscriptionPlanSelectionRoute) {
            this._router.navigate([this.subscriptionPlanSelectionRoute], { replaceUrl: true }).catch((error) => {
              console.warn('Failed to redirect to subscription plan selection', error);
            });
          }
        },
        () => {
          // Ignore if summary cannot be loaded here.
        }
      );
  }

  private enforceRestrictedNavigation(url: string): void {
    if (!this.restrictToRenewalFlow || !this.isLoggedIn()) {
      return;
    }

    // If subscription has been confirmed active by any check, lift the restriction
    if (localStorage.getItem('SubscriptionExpired') === 'false') {
      this.restrictToRenewalFlow = false;
      return;
    }

    const currentUrl = String(url || '').split('?')[0].split('#')[0];
    const isAllowedRoute = this.renewalAllowedRoutePrefixes.some((prefix) => currentUrl.startsWith(prefix));

    if (isAllowedRoute) {
      return;
    }

    this._router.navigate([this.subscriptionPlanSelectionRoute], { replaceUrl: true }).catch((error) => {
      console.warn('Failed to enforce renewal route restriction', error);
    });
  }

  private shouldRedirectToPlanSelection(summary: any): boolean {
    const mode = String(summary?.subscriptionMode || summary?.status || '').toUpperCase();
    const hasActiveSubscription = summary?.subscriptionActive === true || summary?.active === true;
    const hasTrial = summary?.trialActive === true;
    const hasSubscriptionRecord = !!(summary?.pricingId || summary?.subscriptionId || summary?.pricingName || summary?.currentPlanName);

    if (hasActiveSubscription || hasTrial) {
      return false;
    }

    if (!hasSubscriptionRecord) {
      return true;
    }

    return mode === 'EXPIRED'
      || mode === 'INACTIVE'
      || mode === 'CANCELLED'
      || mode === 'CLOSED';
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();
}
